import React, { useEffect, useState } from 'react';
import { Breadcrumb, Popover } from 'react-bootstrap';
import './Breadcrumb.css';
import Auth from './../../../utils/auth';
import Bell from './../../../assets/svg/IconBell.svg';
import Info from './../../../assets/svg_main/help-circle-contained.svg';
import DownArrow from './../../../assets/svg_main/downArrow.svg';
import Cross from './../../../assets/svg_main/CrossIcon.svg';
import { useNavigate } from 'react-router-dom';
import OverlayCard from '../OverlayCard';
import Button from '../Button';
import { getData } from './../../../services/CommonApiService';
import endpoints from '@config/endpoints';
import convertByteToImageURL from './../../../utils/convertByteToImageURL';
import profilePic from './../../../assets/png/default_profile.png';
import EditIcon from './../../../assets/svg_main/pencil-01.svg';
import LocationIcon from './../../../assets/svg_main/marker-02.svg';
import LogoutIcon from './../../../assets/svg_main/logout-04.svg';
import ProfileIcon from './../../../assets/svg_main/user-profile-02.svg';
import SettingsIcon from './../../../assets/svg_main/settingIcon.svg';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';
import { errorLogger } from '@utils/applicationLogUtils';

interface BreadcrumbProps {
  breadcrumbItemName: { value: string; label: string }[];
}
const BreadcrumbComponent: React.FC<BreadcrumbProps> = ({
  breadcrumbItemName,
}) => {
  const navigate = useNavigate();
  const [show, setShow] = useState<boolean>(false);
  const storedUserId = localStorage.getItem('userId');
  const isBeneficiaryLogged = localStorage.getItem('isBeneficiaryLogged') || 'false';
  const [beneficiaryLoggedIn, setBeneficiaryLoggedIn] = useState<boolean>(isBeneficiaryLogged==="true");
  const [imageURL, setImageURL] = useState<any>("");
  const [userData, setUserData] = useState<any>();
  const [roleData, setRoleData] = useState<string>();
  const user = JSON.stringify(Auth.userId());
  const name = JSON.parse(user).given_name;
  const benefDetails=localStorage.getItem('beneficiaryDetails');
  const beneficiaryDetails= benefDetails ?JSON.parse(decodeWithKeyAndShift(benefDetails)):null;
  const options: any = [
    { value: 'Logout', label: 'Logout' }
  ];

  const handleDropdownsearchableChange = () => {
    navigate("/logout", { replace: true });

  };
  const handleClose = () => {
    setShow(false);
  }
  //function to check whether item is there in local storage
  const checkItemInLocalStorage = (key:any) => {
    const item = localStorage.getItem(key);
    return item !== null;
  };

  useEffect(() => {
    const initialFetch = async () => {
      try {

        if (storedUserId) {
          const result: any = await getData<any[]>(`${endpoints.getLoggedUserDetailsWithRolesAndImage}`)
          const res = result?.data?.userDetails[0];
          if (res) {
            const userStateCode = res.state_code;
            const userDistrictCode = res.district_code;
            const userTypeName = res.usertype_name;
            localStorage.setItem('userDetails', encodeWithKeyAndShift(JSON.stringify(res)));
            localStorage.setItem('userStateCode', userStateCode);
            localStorage.setItem('userDistrictCode', userDistrictCode);
            localStorage.setItem('userTypeName', userTypeName);
            setUserData(res);
            try {
              const roles = result?.data?.roles;
              const roleNames = roles.map((item: { role_name: string }) => item.role_name);
              const concatenatedNames = roleNames.join(', ');
              localStorage.setItem('userRoleDetails', encodeWithKeyAndShift(JSON.stringify(concatenatedNames)));
              setRoleData(concatenatedNames);
            }
            catch (e: any) {
              errorLogger(e?.response?.data || e?.response || e)
            }
            try {
              const image = result?.data?.image[0];
              if (image && image?.image?.data) {
                const imageurl = convertByteToImageURL(image.image.data);
                localStorage.setItem('userImageurl', imageurl);
                setImageURL(imageurl);
              }
              else {
                localStorage.setItem('userImageurl', "No Image");
              }
            }
            catch (error: any) {
              localStorage.setItem('userImageurl', "No Image");
            }
          }

        }
      }
      catch (e: any) {
        errorLogger(e?.response?.data || e?.response || e)
      }
    }
    if(isBeneficiaryLogged!=='true' && checkItemInLocalStorage('userId') && checkItemInLocalStorage('userRoleDetails') && checkItemInLocalStorage('userImageurl') && checkItemInLocalStorage('userDetails')){
      const userDetails = localStorage.getItem('userDetails');
      const imageDetails = localStorage.getItem('userImageurl');
      const roleDetails = localStorage.getItem('userRoleDetails');
      const decodedUserData=JSON.parse(decodeWithKeyAndShift(userDetails));
      const decodedRoleDetails=JSON.parse(decodeWithKeyAndShift(roleDetails));
      setImageURL(imageDetails==="No Image"?"":imageDetails);
      setUserData(decodedUserData);
      setRoleData(decodedRoleDetails);
    }
    else{
      isBeneficiaryLogged!=='true' && initialFetch();
    }  
  }, [])
  const nameDropDown = <div className='name_drop_down_svg'>{beneficiaryLoggedIn ? beneficiaryDetails?.benf_name : name}
    <DownArrow />
  </div>


  return (
    <div className='breadcrumb_profilepic_name'>
      <div>
        <Breadcrumb className="custom_breadcrumb_item">
          {breadcrumbItemName?.map((option, index) => (
            <Breadcrumb.Item key={index}>{option.label}</Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </div>
      <div className='right_bell_info_name'>
        <Bell />
        <Info />
        <div className='vertical_line_breadcrumbs_beside_image'></div>
        <div className='view-profile_breadcrumbs'>
          {
            storedUserId && imageURL ? <img
              className="profile-picture"
              src={imageURL}
              alt='Profile Image'
            /> :
              <img
                className="profile-picture"
                src={profilePic}
                alt='Profile Image'
              />
          }
        </div>
        <OverlayCard
          show={show}
          setShow={setShow}
          triggerComponent={nameDropDown}
          trigger="click"
          placement="bottom-end"

          overlayComponent={
            <Popover id="custom_profile_display" placement="auto-start">
              {/* <Popover.Header className='popover_header_breadcrumb' as="h6">
                <div> Profile Info
             
                </div>
              </Popover.Header> */}
              <Popover.Body>
                <div className='popover_body_breadcrumbs_buttons_close'>
                  <Button
                    onClick={handleClose}
                    id=""
                    buttonName={''}
                    colorType={'previous'}
                    icon={<Cross />}
                    iconPosition={'right'}
                  />
                </div>
                <div className='popover_image_name_details' >
                  {/* Profile Image in Popover */}
                  <div className='view-profile_breadcrumbs_popover'>
                    {
                      storedUserId && imageURL ? <img
                        className="profile-picture"
                        src={imageURL}
                        alt='Profile Image'
                      /> :
                        <img
                          className="profile-picture"
                          src={profilePic}
                          alt='Profile Image'
                        />
                    }
                  </div>
                  <div className='profile_breadcrumbs_popover_profile'>
                    <div className="view-profile_breadcrumbs_popover_name" >{beneficiaryLoggedIn ? beneficiaryDetails?.benf_name : `${userData?.first_name} ${userData?.last_name ? userData?.last_name : ""}`}</div>
                    <div className="view-profile_breadcrumbs_popover_role" >
                    <span>{!beneficiaryLoggedIn && roleData?roleData:''}</span>
                      </div>
                    {userData?.state_name && <div className="view-profile_breadcrumbs_popover_location" >
                    <LocationIcon/>
                    <span>{!beneficiaryLoggedIn && `${userData?.district_name ? `${userData?.district_name}, ` : ""}${userData?.state_name ? userData?.state_name : ""}`}</span>
                    </div>}
                  </div>
                </div>
                {/* <div className="breadcrumbs_profile_view_icons_div" >
                
                  <ProfileIcon/> 
                  <span>View Profile</span>
                </div>
                <hr className='breadcrumbs_profile_view_icons_div_hr'></hr>

                <div className="breadcrumbs_profile_view_icons_div" >
                  <SettingsIcon/>
                  <span>Settings</span>
                </div>
                <hr className='breadcrumbs_profile_view_icons_div_hr'></hr> */}
                 <hr className='breadcrumbs_profile_view_icons_div_hr'></hr>
                <div className="breadcrumbs_profile_view_icons_div" onClick={handleDropdownsearchableChange}>
                  <LogoutIcon/>
                  <span>Logout</span>
                </div>
              </Popover.Body>
            </Popover>
          }

        />

      </div>
    </div>

  );
};
export default BreadcrumbComponent;
